module.exports = __webpack_public_path__ + "static/media/wipers.dc984ea3.svg";